const PRIORITIZE_NUDGE_TIMESTAMP = 'mail_priority_inbox_nudge_timestamp';

export { PRIORITIZE_NUDGE_TIMESTAMP };
